import Image from "next/image";
import Script from "next/script";
import React from "react";

interface LinkedInTagsSnippetProps {
  partnerId: string;
}

export const LinkedInTagsSnippet: React.FC<LinkedInTagsSnippetProps> = ({ partnerId }) => {
  // Error on build if we do not have a partnerId for a given page.
  if (!partnerId) {
    throw new Error("LinkedInTagsSnippet: Missing partnerId");
  }

  return (
    <>
      <Script id="linkedin-tags">
        {`
            _linkedin_partner_id = "${partnerId}";
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(_linkedin_partner_id);

            (function(l) {
            if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
            window.lintrk.q=[]}
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);})(window.lintrk);
          `}
      </Script>
      <noscript>
        <Image
          alt=""
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`}
        />
      </noscript>
    </>
  );
};
